import { ContractSchema, CustomerSchema } from '@weft/types';
import type { oz } from '@weft/utils';

export const DynamicInvoicePageCustomerSchema = CustomerSchema.pick({
  id: true,
  name: true,
  settings: true,
});
  
export const DynamicInvoicePageContractSchema = ContractSchema.pick({
  id: true,
}).extend({
  customer: DynamicInvoicePageCustomerSchema,
});

export type DynamicInvoicePageContract = oz.infer<typeof DynamicInvoicePageContractSchema>;
export type DynamicInvoicePageCustomer = oz.infer<typeof DynamicInvoicePageCustomerSchema>;